<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-brand" style="flex-shrink: 2;">
        <a href="/">
          <img :src="logo" alt="gi" class="image logo">
        </a>
        <span :class="[{'is-active': burgerIsActive}, 'navbar-burger', 'burger']" @click="burgerToggle" data-target="navMenu">
        <span></span>
        <span></span>
        <span></span>
        </span>
      </div>
      <div id="navMenu" :class="[{'is-active': burgerIsActive}, 'navbar-menu']">
        <div class="navbar-end">
          <a class="navbar-item" @click="showModal">SEE IT IN ACTION</a>
          <router-link to="/pricing" class="navbar-item">PRICING</router-link>
          <a class="navbar-item" href="#contact-form">CONTACT US</a>
          <a class="navbar-item" href="/advertise-with-us/" target="_blank">ADVERTISE WITH US</a>
          <a href="#contact-form" class="navbar-item get-started-href">
            <span class="get-started">
            GET STARTED
            </span>
          </a>
        </div>
      </div>
    </div>
    <b-modal :active.sync="modalIsActive">
        <b-tabs style="background: #fff; text-align: center;">
            <b-tab-item label="DESKTOP">
              <img :src="cgDesktop"/>
            </b-tab-item>
            <b-tab-item label="TABLET">
              <img :src="cgTablet"/>
            </b-tab-item>
            <b-tab-item label="MOBILE">
              <img :src="cgMobile"/>
            </b-tab-item>
        </b-tabs>
    </b-modal>
  </nav>
</template>
<script>
import logo from './../../assets/images/logo/gi_logo.png';
import cgDesktop from './../../assets/images/siia/desktop.png';
import cgTablet from './../../assets/images/siia/tablet.png';
import cgMobile from './../../assets/images/siia/mobile.png';
export default {
  data() {
    return {
      logo,
      burgerIsActive: false,
      modalIsActive: false,
      cgDesktop,
      cgTablet,
      cgMobile,
    }
  },
  methods: {
    showModal(){
      this.modalIsActive = true;
    },
    burgerToggle(){
      this.burgerIsActive = !this.burgerIsActive;
    }
  }
}
</script>

<style scoped lang="scss">
.logo {
  max-height: 5em; 
  margin: 10px;
}
.navbar-item {
  font-weight: bold;
  padding: .5rem 1rem;
}
a.navbar-item:hover {
  background-color: #fff !important;
}
.get-started-href {
  .get-started {
    border: 3px solid red; 
    padding: 15px 25px 15px 25px; 
    border-radius: 5px;
  }
}
a.navbar-item:hover {
  color: #ff3e45 !important;
}
@media only screen and (max-width: 425px) {
  .get-started-href {
    margin-top: 20px !important;
  }
  .navbar-burger span {
    height: 3px;
    width: 25px;
    margin-bottom: 20px !important;
  }
  #navMenu {
    padding-bottom: 25px;
  }
}
</style>

